let startCID = Date.now()

export default function uniqCid(): number {
  startCID = Math.max(startCID, Date.now())

  return startCID++
}
